<script setup lang="ts">
import { defaultColor } from '@/enums/defaultColor';
import { defineProps, withDefaults } from 'vue';
import { useRouter } from 'vue-router';
interface Props {
  text: string
  color?: defaultColor
  pageName?: string
  disabled?: boolean
}
const props = withDefaults(defineProps<Props>(), { color: defaultColor.PRIMARY, pageName: '', disabled: false })
const router = useRouter()

const emit = defineEmits(['clicked'])
function gotoOrEmit() {
  if (props.pageName == '') {
    emit('clicked', true)
  } else {
    router.push({ name: props.pageName })
  }
}
</script>
<template>
  <button
    class="flex content-center items-center btn-algo w-full lg:w-auto"
    :class="[`btn-algo-${color}`, { 'btn-algo-disabled': disabled }]"
    type="button"
    :disabled="disabled"
    @click="() => gotoOrEmit()"
  >
    <slot name="iconLeft"></slot>
    <span>{{ text }}</span>
    <slot name="iconRight"></slot>
  </button>
</template>
<style>
@import '@/assets/algo-css/components/Button.css';
</style>
